












































import { Vue, Component, State, namespace } from 'nuxt-property-decorator'
import SelectedTagList from '~/components/experience/destinations-category-tree/selected-tag-list.vue'
import RangesTree from '~/components/experience/destinations-category-tree/ranges-tree.vue'
import CategoryTree from '~/components/experience/destinations-category-tree/category-tree.vue'
import { Experience } from '~/types/experience'
import DesktopTreeModal from '~/components/experience/destinations-category-tree/desktop/desktop-tree-modal.vue'

import TreeNode = Experience.TreeNode

const experience = namespace('experience')

@Component({
  components: {
    RangesTree,
    CategoryTree,
    SelectedTagList,
    DesktopTreeModal
  }
})

export default class DestinationsCategoryTree extends Vue {
  @State klook!: Data.Klook
  @experience.State categoryTreeData!: TreeNode []
  @experience.State rangeData!: TreeNode []
  @experience.State urlQuery!: any
  @experience.Action setUrlQuery!: Function
  modalShow: boolean = false
  modalType: 'range' | 'category' = 'range'
  treeContainerHeight: string = '800px'

  showRangeModal() {
    this.modalShow = true
    this.modalType = 'range'
  }

  showCategoryModal() {
    this.modalShow = true
    this.modalType = 'category'
  }

  closeModal() {
    this.modalShow = false
  }

  mounted() {
    setTimeout(() => {
      const windowHeight = document.documentElement.clientHeight
      this.treeContainerHeight = windowHeight - 70 + 'px'
    }, 2000)
  }
}
